import { shallowEqual, useSelector } from 'react-redux';
import { loopArray } from 'utils/loopArray';

export default function MenuData() {
  const { user } = useSelector((state) => state.auth, shallowEqual);

  return [
    {
      name: 'Мониторинг',
      url: 'monitoring',
      permission: { ...loopArray(user?.permission, 'Мониторинг') },
    },
    {
      name: 'Отчеты',
      url: 'reports',
      permission: { ...loopArray(user?.permission, 'Отчёты') },
    },
    {
      name: 'Департаменты',
      url: 'departaments',
      permission: { ...loopArray(user?.permission, 'Департамент') },
    },
    {
      name: 'Машины',
      url: 'vehicle',
      permission: { ...loopArray(user?.permission, 'Транспорт') },
    },
    {
      name: 'Точки доступа',
      url: 'access',
      permission: { ...loopArray(user?.permission, 'Точка доступа') },
      hidden: true,
    },
    {
      name: 'Сервера',
      url: 'server',
      permission: { ...loopArray(user?.permission, 'Сервер') },
      hidden: true,
    },
    {
      name: 'Датчики',
      url: 'tanks',
      permission: { ...loopArray(user?.permission, 'Баки') },
    },
    {
      name: 'Пользователи',
      url: 'user',
      permission: { ...loopArray(user?.permission, 'Пользователь') },
    },
    {
      name: 'Роли',
      url: 'role',
      permission: [],
    },
    {
      name: 'Профиль',
      menu: true,
      permission: ['read'],
    },
  ];
}
